/* eslint-disable sort-keys */
export const queueButton = {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    button: {
        padding: '$button',
        justifyContent: 'space-between',
        width: '100%',
        span: {
            textAlign: 'center',
            width: '100%',
        },
    },
    variants: {
        align: {
            center: {
                'justifyContent': 'center',
                '> div': {width: 'auto'},
            },
            right: {
                'justifyContent': 'flex-end',
                '> div': {width: 'auto'},
            },
            left: {
                'justifyContent': 'flex-start',
                '> div': {width: 'auto'},
            },
        },
        inline: {
            true: {
                display: 'inline-flex',
                paddingRight: '10px',
                width: 'auto',
            },
        },
        textAlign: {
            center: {},
            left: {'button > span': {textAlign: 'left'}},
            right: {'button > span': {textAlign: 'right'}},
        },
    },
}

export const queueButtonInner = {width: '100%'}

export const buttonIcon = {
    display: 'flex',
    alignItems: 'center',
}
